// React Core Imports
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import Lenis from '@studio-freight/lenis'

// Components & Data Imports
import MainPage from './pages/MainPage'
import Navigation from './layout/Navigation'

// Style Imports
import './sass/main.scss'

function App() {
  useEffect(() => {
    // Inicializace
    const lenis = new Lenis({
      duration: 1.2,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    })

    // Propojení s vykreslováním prohlížeče
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    // Uložíme si lenis do window, abychom k němu mohli z navigace
    window.lenis = lenis

    return () => {
      lenis.destroy()
    }
  }, [])

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path='/' element={<MainPage />} />
        <Route path='*' element={<MainPage />} />
      </Routes>
    </Router>
  )
}

export default App
